import {
    getCvsWorkingEnvironments, updateUrlParams, wizardStepExited, wizardStepStarted
} from '../../../store/wizard/action_creators';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import AnfWeCard from './AnfWeCardNew';
import { getAnfWorkingEnvironments } from '../../../utils/data-utils';
import {
    buildServersList,
    getPropFromState,
    getWizardParamsFromWizardState
} from '../../../utils/mapStateToPropsUtils';
import WeStepTemplate from "./WeStepTemplateNew";
import { capitalize, find } from 'lodash'
import "./cmWeStepNew.scss";
import useStepinize from "../useStepinize";
import anfDefaultSvg from '.././../../assets/svgs/anf-default.svg?url';

const loading = () => {
    return {
        className: 'anf-we',
        text: 'System',
        icon: anfDefaultSvg
    }
}

const stepId = ({ isTargetStepFromSameSourceType, protocol }) => {
    const protocolCapitalized = capitalize(protocol);
    return isTargetStepFromSameSourceType ? `targetAnf${protocolCapitalized}We` : `anf${protocolCapitalized}We`;
};
const fetchData = (props) => {
    const { _accountInfo, _cmIntegration } = props;
    const accountId = _accountInfo?.data?.accountId;
    const workspaceId = _cmIntegration?.general?.workspaceId;
    props.getCvsWorkingEnvironments(accountId, workspaceId);
};
const shouldFetch = (props) => {
    return !props._cvsWorkingEnvironments || (!props._cvsWorkingEnvironments.inProgress && !props._cvsWorkingEnvironments.succeeded)
};
const isFetching = ({ _cvsWorkingEnvironments }) => {
    return _cvsWorkingEnvironments?.inProgress;
};

const AnfWeStep = (props) => {
    const { LoadingComp, moreStepInfo } = useStepinize({ props, fetchData, shouldFetch, loading, stepId })
    const { isSourceStep, isTargetStepFromSameSourceType, protocol } = moreStepInfo;
    const { _cvsWorkingEnvironments, _cmIntegration: { inputDetails }, clearSelectedParams, state } = props;
    const { viewDashboard, source, target } = inputDetails || {};
    const protocolCapitalized = capitalize(protocol);

    //in case it was selected in the CM gallery
    const showOnlyCmSelection = (isSourceStep ? source?.sourceWorkingEnvironmentType?.toLowerCase() === "anf" : target?.targetWorkingEnvironmentType?.toLowerCase() === 'anf') && !viewDashboard;
    const workingEnvironmentName = isSourceStep ? source?.sourceWorkingEnvironmentName : target?.targetWorkingEnvironmentName;

    const anfWorkingEnvironments = useMemo(() => {
        const anfWe = getAnfWorkingEnvironments(_cvsWorkingEnvironments);
        const selectedWe = find(anfWe, { name: workingEnvironmentName });
        return showOnlyCmSelection && selectedWe ? [selectedWe] : anfWe;
    }, [_cvsWorkingEnvironments, showOnlyCmSelection, workingEnvironmentName]);

    //initialize selection:
    const stepOptions = {
        workingEnvironments: anfWorkingEnvironments,
        selectedStepParamName: `selectedAnf${protocolCapitalized}We`,
        selectedTargetStepParamName: `selectedAnf${protocolCapitalized}WeTarget`,
        showOnlyCmSelection,
        WECard: AnfWeCard,
        getSelectedParams: (we) => {
            const paramName = isTargetStepFromSameSourceType ? `anf${protocolCapitalized}WeTarget` : `anf${protocolCapitalized}We`

            if (state[paramName] && state[paramName] !== we) {
                const hostParam = isTargetStepFromSameSourceType ? `${protocol}ServerTarget` : `${protocol}Server`;
                const versionParam = isTargetStepFromSameSourceType ? `target${protocolCapitalized}Version` : `${protocol}Version`;
                const volParam = isTargetStepFromSameSourceType ? `${protocol}VolTarget` : `${protocol}Vol`;
                const wordForExport = protocol === 'cifs' ? 'share' : 'export';
                const wordForExportCapitalized = capitalize(wordForExport);
                const exportParam = isTargetStepFromSameSourceType ? `root${wordForExportCapitalized}Target` : `root${wordForExportCapitalized}`;
                const pathParam = isTargetStepFromSameSourceType ? `${wordForExport}PathTarget` : `${wordForExport}Path`;

                const stateParamsToClear = [pathParam, exportParam, volParam, versionParam, hostParam];

                clearSelectedParams(stateParamsToClear);
            }


            return {
                [paramName]: we
            }
        }
    }
    return (isFetching({ ...props, ...moreStepInfo }) ? LoadingComp : <WeStepTemplate stepOptions={stepOptions} {...props} {...moreStepInfo} />)
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        _servers: buildServersList(state),
        _wizard: getWizardParamsFromWizardState(state, ownProps, ownProps.state, ownProps.state)._wizard,
        _cvsWorkingEnvironments: getPropFromState(state, "_cvsWorkingEnvironments", {}),
        _relationships: getPropFromState(state, "_relationships", {}),
        _cmIntegration: state.global._cmIntegration,
        routing: state.router,
    }
};

const mapDispatchToProps = {
    getCvsWorkingEnvironments,
    updateUrlParams,
    wizardStepStarted,
    wizardStepExited

};

export default connect(mapStateToProps, mapDispatchToProps)(AnfWeStep);
